// client/src/components/shared/VirtualStagingBadge.js — the "Virtually staged" label.
//
// Every place a listing photo is shown wraps it in <StagedImage>: when the photo is a
// virtually staged derivative (property_media.is_virtually_staged) the label is drawn
// over the image itself, not only in a caption, so a screenshot or a crop of the page
// still carries it. The server also forces the caption to start "Virtually staged".
import React from 'react';

export const isStaged = (m) => !!(m && (m.is_virtually_staged === true || Number(m.is_virtually_staged) === 1 || m.virtually_staged === true));

export const VirtualStagingBadge = ({ className = '' }) => (
    <span className={`absolute left-2 top-2 z-10 rounded bg-black/80 px-2 py-0.5 text-xs font-semibold text-white pointer-events-none ${className}`}>
        Virtually staged
    </span>
);

/** An <img> with the overlay when `staged`. Extra props go to the <img>. */
export const StagedImage = ({ staged, wrapperClassName = '', ...img }) => (
    <div className={`relative ${wrapperClassName}`}>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img {...img} />
        {staged && <VirtualStagingBadge />}
    </div>
);

export default VirtualStagingBadge;
